import { css, genDynamicVariant } from '@backyard-ui/styles';

const baseStyles = css({
  display: 'grid',
  variants: {
    gap: genDynamicVariant('space', (value) => ({
      gridGap: value,
    })),
    columnGap: genDynamicVariant('space', (value) => ({
      gridColumnGap: value,
    })),
    rowGap: genDynamicVariant('space', (value) => ({
      gridRowGap: value,
    })),
    spacing: genDynamicVariant('space', (value) => ({
      gridGap: value,
    })),
    spacingX: genDynamicVariant('space', (value) => ({
      gridColumnGap: value,
    })),
    spacingY: genDynamicVariant('space', (value) => ({
      gridRowGap: value,
    })),
  },
});

export default baseStyles;
